export const setList = (state, payload) => (state.list = payload)

export const setAmountList = (state, payload) => (state.amountList = payload)

export const setMonthData = (state, payload) => (state.monthData = payload)
